export const StaffHeader = ["Name", "Role", "Phone #", "Address", "Email"];


// export const ShiftHeader = ["Name", "Role", "Shift Type", "Timings", "Shift Status"];
export const ShiftHeader = ["Name", "Role", "Shift Type", "Timings"];
export const StaffPermissionHeader = [
  "Permissions",
  "View",
  "Edit",
  "Add",
  "Delete",
];

// export const ShiftMemberDetailsHeader = [
//   "Date", "Shift Type", "Shift Status", "Timings", "Check In", "Check Out", "Shift Hours"
// ]

export const ShiftMemberDetailsHeader = [
  "Date", "Shift Type", "Timings", "Check In", "Check Out", "Shift Hours"
]
